import { useLocation } from 'react-router-dom';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiSubsite } from 'modules/cms/api/types/CmsApiSubsite';

type Props = {
  cmsApiPage: CmsApiPage | undefined;
};

type ContentSubsiteLocationState = {
  subsite: CmsApiSubsite;
};

export function useCmsApiPageSubsite({
  cmsApiPage,
}: Props): CmsApiSubsite | undefined {
  const location = useLocation();
  const state = location.state as ContentSubsiteLocationState;

  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  return state && state.subsite
    ? {
        ...state.subsite,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        defaultSearchType: cmsApiPage.subsite.defaultSearchType,
      }
    : cmsApiPage && cmsApiPage.subsite;
}
